import PropTypes from 'prop-types';

const performanceStatics = PropTypes.shape({
  averageOverviewRating: PropTypes.number.isRequired,
  conversionRate: PropTypes.number.isRequired,
  averagePrice: PropTypes.number.isRequired,
  rankingScore: PropTypes.string.isRequired,
});

const performanceOverviews = PropTypes.shape({
  data: PropTypes.shape({
    totalAmountReceived: PropTypes.number,
    totalNights: PropTypes.number,
    averagePrice: PropTypes.number,
  }),
  compareData: PropTypes.shape({
    totalAmountReceived: PropTypes.number,
    totalNights: PropTypes.number,
    averagePrice: PropTypes.number,
  }),
});

const performanceChart = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  startedAt: PropTypes.string.isRequired,
  endedAt: PropTypes.string.isRequired,
  nights: PropTypes.number.isRequired,
  actualAmountReceived: PropTypes.number.isRequired,
  averagePrice: PropTypes.number.isRequired,
});

const AnalyticsPropTypes = {
  performanceChart,
  performanceStatics,
  performanceOverviews,
};

export default AnalyticsPropTypes;
